var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsuranceInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.27539 2.15426C7.74132 1.97332 8.25872 1.97316 8.72461 2.15426L12.3779 3.57516C12.8968 3.77719 13.2391 4.27713 13.2393 4.83395V6.20407C13.2393 9.19945 11.6478 11.97 9.06055 13.4795C8.40529 13.8615 7.59478 13.8613 6.93945 13.4795C4.35192 11.9701 2.76074 9.19966 2.76074 6.20407V4.83395C2.76088 4.27694 3.10291 3.77705 3.62207 3.57516L7.27539 2.15426ZM8 6.86227C7.58675 6.86227 7.25121 7.19713 7.25098 7.61032V10.6045C7.25098 11.0178 7.58661 11.3535 8 11.3535C8.41328 11.3533 8.74805 11.0178 8.74805 10.6045V7.61032C8.74781 7.19721 8.41313 6.8624 8 6.86227ZM8 4.61715C7.58666 4.61715 7.25105 4.95187 7.25098 5.3652C7.25098 5.77859 7.58661 6.11422 8 6.11422C8.41328 6.11409 8.74805 5.77851 8.74805 5.3652C8.74797 4.95195 8.41323 4.61728 8 4.61715Z",
    fill: "#002A69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsuranceInfo);
export default __webpack_public_path__ + "static/media/Insurance_info.9a75d39fc901de21fdbfbc745a762ff7.svg";
export { ForwardRef as ReactComponent };